import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const ReceiptPrint = ({ data }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");
  const ticket = data?.ticket || {};
  const item = data?.item || {};

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      orderLine={{ label: `${t("print.ticketNumber")}:`, value: ticket.ticket_number || "-" }}
      rows={[
        { label: `${t("print.patientName")}:`, value: ticket.patient_name || "-" },
        { label: `${t("reception.type", "Type")}:`, value: item.type_display || item.label || "-" },
        ...(item.doctor_display ? [{ label: `${t("pharmacy.doctor")}:`, value: item.doctor_display }] : []),
        ...(item.date ? [{ label: `${t("reception.date")}:`, value: item.date }] : []),
      ]}
      totals={[{ label: t("print.totalAmount"), value: money(item.amount), bold: true }]}
      footerLines={[t("print.thanks"), t("print.getWellSoon"), t("print.cosmos")]}
    />
  );
};

export default ReceiptPrint;
